export default __webpack_public_path__ + "static/media/siteContentIcon.0e64000b.svg";